import { IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { Skeleton } from '@material-ui/lab';
import type { FC } from 'react';

import { useInfiniteScroll } from '../../../../hooks/infinite-scroll.hooks';
import type {
  AccountAsset,
  Asset,
} from '../../../../lib/graph/MogulMarketplace';
import assetOwnersQuery from '../../../../lib/graph/queries/assetOwnersQuery';
import { Panel } from '../../panel/Panel.component';
import styles from './OwnerModal.module.css';

export interface OwnersModalProps {
  asset: Asset;
}
export interface OwnersProps extends OwnersModalProps {
  hideModal: () => void;
}

const Owners: FC<OwnersProps> = ({ asset, hideModal }: OwnersProps) => {
  const { loading, fetchedData, loader } = useInfiniteScroll<{
    accountAssets: AccountAsset[];
  }>(
    assetOwnersQuery,
    {
      accountAssets: [],
    },
    curr => prev => ({
      accountAssets: [...prev.accountAssets, ...curr.accountAssets],
    }),
    d => !d.accountAssets.length,
    {
      variables: {
        assetId: asset.id,
        first: 20,
      },
    },
  );

  return (
    <Panel
      className="overflow-hidden"
      bodyClassName={styles.panel + ' flex flex-col rounded-lg'}
    >
      <div className="flex justify-center w-full">
        <h1 style={{ fontSize: 42, color: 'gold' }}>Owners</h1>
        <div className="relative">
          <IconButton
            className={'h-10 w-10 top-2 left-16 z-30'}
            style={{
              background: '#000000',
              border: 'none',
              position: 'absolute',
            }}
            onClick={hideModal}
          >
            <ClearIcon style={{ color: 'white' }} />
          </IconButton>
        </div>
      </div>
      <div
        className={
          styles.ownerScroll + ' flex flex-col max-h-96 overflow-y-auto'
        }
      >
        {loading
          ? Array.from(Array(10).keys()).map(i => (
              <Skeleton height={75} key={i} />
            ))
          : fetchedData.accountAssets.map((accountAsset: AccountAsset) => {
              // TODO: add route to user profile when addresses linked to accounts
              return (
                <div key={accountAsset.id} className="mb-5">
                  <p>{accountAsset.account.address}</p>
                </div>
              );
            })}
        <div className="h-px" ref={loader}></div>
      </div>
    </Panel>
  );
};
export const OwnersModal =
  (props: OwnersModalProps) =>
  ({ hideModal }: OwnersProps) => {
    return <Owners hideModal={hideModal} {...props} />;
  };
